import { useState } from "react";
import { BellRing } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { SubscribePanel } from "@/components/SubscribePanel";

const DAY = 86400000;
const WARN_DAYS = 14;

export const RenewReminder = ({ until }) => {
  const { t, lang } = useLang();
  const s = t.sub;
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const left = Math.ceil((new Date(until).getTime() - Date.now()) / DAY);
  const date = new Date(until).toLocaleDateString(lang);

  if (left > WARN_DAYS || left < 1) return <p className="mt-4 text-xs text-stone-600" data-testid="subscription-until">{s.until(date)}</p>;
  if (open) return <SubscribePanel renewing />;
  if (hidden) return <p className="mt-4 text-xs font-semibold text-[#B91C1C]" data-testid="subscription-until">{s.soon(left, date)}</p>;
  return (
    <div className="rounded-2xl border-2 border-[#F59E0B] bg-[#FFFBEB] p-4 flex flex-col sm:flex-row sm:items-center gap-3 max-w-3xl" data-testid="renew-reminder">
      <BellRing className="w-6 h-6 text-[#B45309] shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-bold text-[#7C2D12]" data-testid="renew-reminder-days">{s.soon(left, date)}</p>
        <p className="text-sm text-stone-700 mt-0.5">{s.soonBody}</p>
      </div>
      <div className="flex gap-2 shrink-0">
        <button onClick={() => setOpen(true)} data-testid="renew-reminder-renew-btn"
          className="rounded-full bg-[#B45309] text-white px-5 py-2 text-sm font-semibold hover:bg-[#8B3A2B] transition-colors">{s.renewNow}</button>
        <button onClick={() => setHidden(true)} data-testid="renew-reminder-later-btn"
          className="rounded-full border border-stone-400 px-4 py-2 text-sm hover:bg-white transition-colors">{s.later}</button>
      </div>
    </div>
  );
};
